import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../AuthContext'

const Banner = () => {
    const {user}=useAuth()
    return (
        <div>
            <section className="banner">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-lg-8">
                            <div className="banner-content center-heading">
                                <h1>NEET Practice. <br />Real CBT Experience</h1>
                                <a href="#recommonded-courses" className="btn btn-main mr-2" style={{ backgroundColor: '#8000d5', borderColor: '#8000d5' }}><i className="fa fa-list-ul mr-2"></i>our Courses </a>
                                {
                                    user&&user.email?
                                    <Link to={`/student/${user.email}`} className="btn btn-tp">get Started <i className="fa fa-angle-right ml-2"></i></Link>:
                                    <Link to={`/login`} className="btn btn-tp">get Started <i className="fa fa-angle-right ml-2"></i></Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="feature">
                <div className="container">
                    <div className="row no-gutters">
                        <div className="col-lg-4 col-md-6">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="bi bi-badge2"></i>
                                </div>
                                <div className="feature-text">
                                    <h4>Learn from Industry Experts</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="bi bi-article"></i>
                                </div>
                                <div className="feature-text">
                                    <h4>Learn the Concepts Clearly</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="bi bi-headset"></i>
                                </div>
                                <div className="feature-text">
                                    <h4>Liable Access & Support</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Banner
